export const numDate2String = (date: any) => {
  if (!date) return "";
  const year = date.substring(0,4)
  const month = date.substring(4,6)
  const day = date.substring(6,8)
  const result = `${year}-${month}-${day}`
  return result;
};
